module.exports = __webpack_public_path__ + "img/molde-logo-icon.c4c6c232.png";